import { EntitiesStructure } from 'common/types/Page'
import { DiagnosticFinding, DiagnosticRule } from '../types'

export const hiddenEntitiesRule: DiagnosticRule = {
  id: 'hidden-entities',
  name: 'Hidden Entities',
  run: (entities: EntitiesStructure): DiagnosticFinding[] => {
    const findings: DiagnosticFinding[] = []

    for (const entity of Object.values(entities)) {
      const appearance = 'appearance' in entity && entity.appearance
      if (!appearance) {
        continue
      }

      if (appearance.desktop === false && appearance.mobile === false) {
        findings.push({
          ruleId: 'hidden-entities',
          severity: 'warning',
          entityId: entity.id,
          entityType: entity.type,
          message: `${entity.type} is hidden on both desktop and mobile`,
        })
      }
    }

    return findings
  },
}
